import type { TableFilterState } from '@ibsys/kit';

/**
 * Поле поиска в шапке раздела задаёт то же условие по названию файла, что и остальные условия
 * списка, — колонкой `fileName`. Так поиск сочетается с отбором и порядком по «И», сохраняется
 * вместе с видом списка и сам перезапрашивает список при изменении.
 */
export const FILE_NAME_FILTER_ID = 'fileName';

/** Набранный фрагмент названия из состояния списка; условия нет — пустая строка */
export const readFileNameFilter = (filters: TableFilterState): string => {
  const filter = filters.find((item) => item.id === FILE_NAME_FILTER_ID);
  return typeof filter?.value === 'string' ? filter.value : '';
};

/** Состояние списка с новым фрагментом названия; пустой фрагмент условие снимает */
export const writeFileNameFilter = (filters: TableFilterState, fileName: string): TableFilterState => {
  const rest = filters.filter((item) => item.id !== FILE_NAME_FILTER_ID);
  return fileName ? [...rest, { id: FILE_NAME_FILTER_ID, value: fileName }] : rest;
};
